const namespace = "dashboard";

export const question_dashboard = `${namespace}_question`;
